import script from "./Wrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Wrapper.vue?vue&type=script&setup=true&lang=ts"

import "./Wrapper.vue?vue&type=style&index=0&id=464b0844&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464b0844"]])

export default __exports__